import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useLocation, useParams } from 'react-router';
import ViewSuppliersV2 from '../../components/buyerSupplier/ViewSuppliersV2';

const SupplierBuyerPage: React.FC = () => {

  const { name } = useParams<{ name: string; }>();
  let orgPageTitle = '';
  console.log(name);
  const location = useLocation();
  console.log(location.pathname);
  if (location.pathname.includes("create-supplier") || location.pathname.includes("view-suppliers ")) {
    orgPageTitle = "Supplier";
  } else if (location.pathname.includes("create-buyer")) {
    orgPageTitle = "Buyer";
  } else {
    orgPageTitle = "organization";
  }
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{orgPageTitle}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar color="primary">
            <IonTitle size="large">{orgPageTitle}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <ViewSuppliersV2 name={orgPageTitle} />
      </IonContent>
    </IonPage>
  );
};

export default SupplierBuyerPage;
